require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zg-pc-ch.json") })
        }
      }, "path---photos-professional-zg-pc-ch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zg-pc-ch!./.cache/json/photos-professional-zg-pc-ch.json
// module id = 1212
// module chunks = 231608221292675